import { ShieldCheck, Clock, FileCheck, HeartHandshake, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function WhyTraceSection() {
  const navigate = useNavigate();

  const reasons = [
    {
      icon: <ShieldCheck size={22} />,
      title: "Sécurité renforcée",
      desc: "En cas d'urgence, nous vous localisons et vous assistons rapidement.",
    },
    {
      icon: <Clock size={22} />,
      title: "Suivi en temps réel",
      desc: "Suivez l'état de votre voyage et de vos demandes à chaque étape.",
    },
    {
      icon: <FileCheck size={22} />,
      title: "Conformité légale",
      desc: "Voyagez en toute légalité selon les réglementations du Niger.",
    },
    {
      icon: <HeartHandshake size={22} />,
      title: "Assistance 24/7",
      desc: "Notre équipe est disponible à tout moment pour vous accompagner.",
    },
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="grid lg:grid-cols-3 gap-6 items-start">
        {/* Left: reasons */}
        <div className="lg:col-span-2">
          <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-5">
            Pourquoi choisir Niger Voyage ?
          </h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {reasons.map((r, i) => (
              <div
                key={i}
                className="bg-white border border-slate-100 rounded-xl p-4 flex gap-3 hover:shadow-md transition-all"
              >
                <div className="w-11 h-11 rounded-lg bg-brand-50 text-brand-600 flex items-center justify-center flex-shrink-0">
                  {r.icon}
                </div>
                <div>
                  <h3 className="font-bold text-slate-800 text-sm mb-0.5">{r.title}</h3>
                  <p className="text-slate-500 text-xs leading-relaxed">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: help card */}
        <div className="bg-brand-600 rounded-2xl p-5 text-white">
          <div className="w-11 h-11 bg-white/15 rounded-xl flex items-center justify-center mb-3">
            <Users size={22} />
          </div>
          <h3 className="font-black text-lg mb-1">Besoin d'aide ?</h3>
          <p className="text-white/85 text-sm mb-4 leading-relaxed">
            Contactez notre centre d'assistance disponible 24h/24, 7j/7.
          </p>
          <button
            onClick={() => navigate("/contact")}
            className="w-full bg-white text-brand-700 font-bold py-2.5 rounded-xl hover:bg-brand-50 transition-colors text-sm"
          >
            Nous contacter
          </button>
        </div>
      </div>
    </section>
  );
}
